//Auth Types
export const LOAD = "LOAD";
export const TYPE = "TYPE";
export const KEYSTORE = "KEYSTORE";
export const METAMASK = "METAMASK";
export const XDEFI = "XDEFI";
export const WALLETCONNECT = "WALLETCONNECT";
export const REGISTER_MSG = "REGISTER_MSG";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const COINMARKETCAP_SUCCESS = "COINMARKETCAP_SUCCESS";
export const COINMARKETCAP_FAIL = "COINMARKETCAP_FAIL";
export const MIDGARDPOOL_REQUESTING = "MIDGARDPOOL_REQUESTING";
export const MIDGARDPOOL_SUCCESS = "MIDGARDPOOL_SUCCESS";
export const MIDGARDPOOL_SUCCESS_INTERVAL = "MIDGARDPOOL_SUCCESS_INTERVAL";
export const MIDGARDPOOL_FAIL = "MIDGARDPOOL_FAIL";
export const KEYSTORECONNECTION_REQUESTING = "KEYSTORECONNECTION_REQUESTING";
export const KEYSTORECONNECTION_SUCCESS = "KEYSTORECONNECTION_SUCCESS";
export const KEYSTORECONNECTION_FAIL = "KEYSTORECONNECTION_FAIL";
export const KEYSTORE_TRANSACTIONHISTORY_REQUESTING =
  "KEYSTORE_TRANSACTIONHISTORY_REQUESTING";
export const KEYSTORE_TRANSACTIONHISTORY_SUCCESS =
  "KEYSTORE_TRANSACTIONHISTORY_SUCCESS";
export const KEYSTORE_TRANSACTIONHISTORY_FAIL =
  "KEYSTORE_TRANSACTIONHISTORY_FAIL";
export const LOGOUT = "LOGOUT";
export const SET_SETTINGS = "SET_SETTINGS";
export const LOGIN = "LOGIN";
export const MAINMODAL = "MAINMODAL";
export const TRANSACTION_HISTORY_MODAL = "TRANSACTION_HISTORY_MODAL";
export const SET_GRAPH_DATA = "SET_GRAPH_DATA";
export const SET_CANDLE_GRAPH_DATA = "SET_CANDLE_GRAPH_DATA";
export const SET_NOTIFICATIONS_DATA = "SET_NOTIFICATIONS_DATA";
export const SWAPPING_REQUEST = "SWAPPING_REQUEST";
export const SWAPPING_SUCCESS = "SWAPPING_SUCCESS";
export const SWAPPING_FAILED = "SWAPPING_FAILED";
export const ADDLIQUIDITY_REQUEST = "ADDLIQUIDITY_REQUEST";
export const ADDLIQUIDITY_SUCCESS = "ADDLIQUIDITY_SUCCESS";
export const ADDLIQUIDITY_FAILED = "ADDLIQUIDITY_FAILED";

export const GETLIQUIDITY_REQUEST = "GETLIQUIDITY_REQUEST";
export const GETLIQUIDITY_SUCCESS = "GETLIQUIDITY_SUCCESS";
export const GETLIQUIDITY_FAILED = "GETLIQUIDITY_FAILED";

export const CLOSE_TRANSACTIONHISTORY_MODAL = "CLOSE_TRANSACTIONHISTORY_MODAL";

export const TOTAL_LIQUIDITY_PROVIDING = "TOTAL_LIQUIDITY_PROVIDING";
